import styled from 'styled-components';

export const BannerContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #1976d2;
    color: white;
    padding: 8px 12px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    position: relative;
    z-index: 0;
    width: 100%;
    box-sizing: border-box;
`;

export const BannerText = styled.div`
    font-size: 14px;
    font-weight: 500;
    flex: 1;
    text-align: center;
    margin: 0 16px;
`;

export const StopButton = styled.button`
    background-color: rgba(255, 255, 255, 0.2);
    color: white;
    border: 1px solid rgba(255, 255, 255, 0.3);
    border-radius: 4px;
    padding: 8px 16px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;
    white-space: nowrap;

    &:hover {
        background-color: rgba(255, 255, 255, 0.3);
        border-color: rgba(255, 255, 255, 0.5);
    }

    &:active {
        background-color: rgba(255, 255, 255, 0.4);
    }

    &:focus {
        outline: none;
        box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.5);
    }
`;
